import script from "./AppNavBarPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavBarPublic.vue?vue&type=script&setup=true&lang=js"

import "./AppNavBarPublic.vue?vue&type=style&index=0&id=00b08444&lang=scss&scoped=true"

import exportComponent from "/builds/partout-chez-nous/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b08444"]])

export default __exports__